import { getBrowserAuthoringNormalizers } from "./browser-authoring-normalizers"

/**
 * @param {object} schedule
 * @param {ReturnType<typeof import("./browser-authoring-normalizers").createBrowserAuthoringNormalizers>} [normalizers]
 * @returns {object}
 */
export function prepareScheduleForAuthoringComparison(schedule, normalizers = getBrowserAuthoringNormalizers()) {
    if (!schedule) return schedule

    const {
        stripAuthoringComparisonArtifacts,
        normalizeAuthoringComparisonText,
        normalizeAuthoringComparisonDiffHtml,
    } = normalizers

    return {
        ...schedule,
        $comparisonNormalizeString: normalizeAuthoringComparisonText,
        $comparisonNormalizeHtml: normalizeAuthoringComparisonDiffHtml,
        title: cleanField(schedule.title),
        code: cleanField(schedule.code),
        intro: schedule.intro
            ? {
                  ...schedule.intro,
                  content: cleanField(schedule.intro.content),
                  note: cleanField(schedule.intro.note ?? schedule.intro.notes),
              }
            : schedule.intro,
        tasks: schedule.tasks?.map((task) => cleanTask(task, normalizers)),
    }

    function cleanField(value) {
        if (typeof value !== "string") return value
        return stripAuthoringComparisonArtifacts(value)
    }
}

function cleanTask(task, normalizers) {
    const {
        normalizeAuthoringComparisonText,
        normalizeAuthoringComparisonDiffHtml,
        stripAuthoringComparisonArtifacts,
    } = normalizers

    const taskWithoutUnitOfMeasure = { ...task }
    delete taskWithoutUnitOfMeasure.unitOfMeasure

    return {
        ...taskWithoutUnitOfMeasure,
        $comparisonNormalizeString: normalizeAuthoringComparisonText,
        $comparisonNormalizeHtml: normalizeAuthoringComparisonDiffHtml,
        linkedFields: normalizeLinkedFields(task.linkedFields),
        title: cleanField(task.title),
        content: cleanField(task.content),
        note: cleanField(task.note),
    }

    function cleanField(value) {
        if (typeof value !== "string") return value
        return stripAuthoringComparisonArtifacts(value)
    }
}

function normalizeLinkedFields(linkedFields = {}) {
    if (!linkedFields || typeof linkedFields !== "object") return {}

    const normalized = {}
    for (const [key, value] of Object.entries(linkedFields)) {
        if (value) normalized[key] = true
    }
    return normalized
}
